import React from 'react'
import { MuiPickersUtilsProvider, DatePicker } from 'material-ui-pickers'
import moment from 'moment'
import 'moment/locale/pl'
import MomentUtils from '@date-io/moment'

moment.locale('pl')

const CustomDatePicker = ({
  name,
  label,
  value,
  onChange,
  minDate,
  maxDate,
  error,
}) => (
  <MuiPickersUtilsProvider utils={MomentUtils}>
    <DatePicker
      className="date-picker"
      name={name}
      label={label}
      value={!value ? null : value}
      onChange={onChange}
      error={error}
      minDate={minDate ? new Date(minDate) : new Date(1900, 0, 1)}
      maxDate={maxDate ? new Date(maxDate) : new Date(2199, 11, 31)}
      keyboard
      mask={[/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/]}
      clearable
      clearLabel="WYCZYŚĆ"
      cancelLabel="Anuluj"
      invalidDateMessage="Nieprawidłowy format daty"
      autoOk
      allowKeyboardControl
      format="YYYY-MM-DD"
      minDateMessage="Data spoza zakresu"
      maxDateMessage="Data spoza zakresu"
      initialFocusedDate={null}
    />
  </MuiPickersUtilsProvider>
)

export default CustomDatePicker
